import React from "react";
import FooterCalculatorDialog from "./FooterCalculatorDialog";

const LoginCalculatorDialog = ({ open, onClose, primaryColor }) => (
  <FooterCalculatorDialog open={open} onClose={onClose} primaryColor={primaryColor} />
);

export default LoginCalculatorDialog;
